import { Button } from "@/components/ui/button";

export const EmptyState = ({
  icon: Icon,
  image,
  title,
  description,
  actionLabel,
  onAction,
  testid,
}) => {
  return (
    <div
      data-testid={testid || "empty-state"}
      className="relative flex flex-col items-center justify-center overflow-hidden rounded-2xl border-2 border-dashed border-[#DCE3F2] bg-[#F7F9FE] px-6 py-12 text-center"
    >
      {image ? (
        <img src={image} alt="" className="mb-4 h-28 w-auto object-contain drop-shadow-sm" />
      ) : Icon ? (
        <div
          className="mb-4 flex h-14 w-14 items-center justify-center rounded-2xl text-white shadow-sm"
          style={{ backgroundColor: "var(--accent-primary)" }}
        >
          <Icon size={26} strokeWidth={2.2} />
        </div>
      ) : null}
      <h4 className="font-heading text-lg font-semibold tracking-tight text-[#14245F]">
        {title}
      </h4>
      {description && (
        <p className="mt-1.5 max-w-md text-sm text-[#5A6B8C]">{description}</p>
      )}
      {actionLabel && (
        <Button
          onClick={onAction}
          data-testid="empty-state-action"
          className="mt-5 rounded-full font-semibold text-white hover:opacity-90"
          style={{ backgroundColor: "var(--accent-primary)" }}
        >
          {actionLabel}
        </Button>
      )}
    </div>
  );
};
